import { editProfileRoutesObj, editProfileBreadcrumbs } from "./path";

import type { IExtendedRouteObject, IPagesParseKey } from "@routes/types";
import { IRole } from "@/interfaces";
import type { IPageMode } from "@/stores/uiStore";
import { useUIStore } from "@/stores/uiStore";

const title: IPagesParseKey = "editProfile";
const pageMode: IPageMode = "edit";

export const editProfileRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: editProfileRoutesObj.edit,
      lazy: () => import("@/pages/adminPanel/editProfile/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, title, editProfileBreadcrumbs.edit, pageMode);
        return {};
      },
    },
    permissions: [IRole.SUPER_ADMIN, IRole.STAFF, IRole.DEPARTMENT_STAFF],
  },
  {
    route: {
      path: editProfileRoutesObj.edit,
      lazy: () => import("@/pages/facultyMemberPanel/editProfile/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, title, editProfileBreadcrumbs.edit, pageMode);
        return {};
      },
    },
    permissions: [IRole.FACULTY_MEMBER],
  },
];
